import React from 'react';

function Header() {

  return (
    <div className='Header'>
        <h1>Adapted Physical Education Assessment Tools</h1>
        <p>Quickly find the appropriate assessment tools for your students with disabilities in physical education.</p>
    </div>
  );
}

export default Header;
